<template>
    <div class="buttons-orange">
        <Link
            v-if="url && (url.startsWith('/') || url.startsWith($page.props.brand.url))"
            :href="url"
            class="link"
            :class="isLoading ? 'link--loading' : ''"
        >
            {{ text }}
        </Link>
        <a
            v-else-if="url"
            :href="url"
            class="link"
            :class="isLoading ? 'link--loading' : ''"
            :target="url.startsWith('#') ? '_self' : '_blank'"
        >
            {{ text }}
        </a>
        <div
            v-else
            class="link"
            :class="isLoading ? 'link--loading' : ''"
            @click="$emit('clicked')"
        >
            {{ text }}
        </div>
    </div>
</template>

<script setup>
defineEmits(['clicked']);

defineProps({
    url: {
        type: String,
        required: false,
        default: null,
    },
    text: {
        type: String,
        required: true,
    },
    isLoading: {
        type: Boolean,
        required: false,
        default: false,
    },
});
</script>
